import { ECountry } from "../contexts/CountryContext";
import { IOption } from "../types/IOption";
import { statesOfArgentina } from "./statesOfArgentina";
import { statesOfBrazil } from "./statesOfBrazil";
import { statesOfPortugal } from "./statesOfPortugal";
import { statesOfSpain } from "./statesOfSpain";
import { statesOfUruguay } from "./statesOfUruguay";
import { statesOfUSA } from "./statesOfUSA";

export interface ICountryOption {
  label: string;
  value: string;
  states: IOption[];
  timezones: IOption[];
}

const timezonesOfBrazil: IOption[] = [
  { value: "America/Sao_Paulo", label: "America/Sao_Paulo" },
  { value: "America/Manaus", label: "America/Manaus" },
];

const timezonesOfPortugal: IOption[] = [
  { value: "Europe/Lisbon", label: "Europe/Lisbon" }, // Portugal continental e Madeira
  { value: "Atlantic/Azores", label: "Atlantic/Azores" }, // Ilhas dos Açores
];

const timezonesOfUruguay: IOption[] = [
  { value: "America/Montevideo", label: "America/Montevideo" },
];

const timezonesOfSpain: IOption[] = [
  { value: "Europe/Madrid", label: "Europe/Madrid" }, // Península e Ilhas Baleares
  { value: "Atlantic/Canary", label: "Atlantic/Canary" }, // Ilhas Canárias
];

const timezonesOfArgentina: IOption[] = [
  { value: "America/Argentina/Buenos_Aires", label: "America/Argentina/Buenos_Aires" },
];

const timezonesOfUSA: IOption[] = [
  { value: "America/New_York", label: "America/New_York" }, // Eastern Time
  { value: "America/Chicago", label: "America/Chicago" }, // Central Time
  { value: "America/Denver", label: "America/Denver" }, // Mountain Time
  { value: "America/Los_Angeles", label: "America/Los_Angeles" }, // Pacific Time
  { value: "America/Anchorage", label: "America/Anchorage" }, // Alaska Time
  { value: "Pacific/Honolulu", label: "Pacific/Honolulu" }, // Hawaii Time
];

export const countries: ICountryOption[] = [
  {
    value: ECountry.Brasil,
    label: "Brasil",
    states: [...statesOfBrazil],
    timezones: [...timezonesOfBrazil],
  },
  {
    value: ECountry.Portugal,
    label: "Portugal",
    states: [...statesOfPortugal],
    timezones: [...timezonesOfPortugal],
  },
  {
    value: ECountry.Uruguai,
    label: "Uruguai",
    states: [...statesOfUruguay],
    timezones: [...timezonesOfUruguay],
  },
  {
    value: ECountry.Espanha,
    label: "Espanha",
    states: [...statesOfSpain],
    timezones: [...timezonesOfSpain],
  },
  {
    value: ECountry.Estados_Unidos,
    label: "Estados Unidos",
    states: [...statesOfUSA],
    timezones: [...timezonesOfUSA],
  },
  {
    value: ECountry.Argentina,
    label: "Argentina",
    states: [...statesOfArgentina],
    timezones: [...timezonesOfArgentina],
  },
];
